import React, { useRef, useState } from "react";
import {
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-hot-toast";
import "./Join.css";

import Lottie from "lottie-react";
import lottie from "../../Assets/Media/LottiesJSONs/HandShake.json";
import { useMediaQuery } from "react-responsive";

const Join = () => {
  const form = useRef();
  const [submitted, setSubmitted] = useState(false);
  const [domain, setDomain] = useState("");
  const [loading, setLoading] = useState(false);

  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });

  const handleOpen = () => {
    if (domain.trim() === "") {
      toast.error("Please enter a domain name first.");
    } else {
      document.getElementById("my_modal_1").showModal();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setDomain("");
      document.getElementById("modal-form").reset();
      setSubmitted(true);
      setLoading(false);
    }, 2000);
  };

  const handleClose = () => {
    setSubmitted(false);
    setLoading(false);
  };

  return (
    <div className="bg-[#eef4f9]">
      <div className="Join container a-container" id="join-us">
        <div className="left-j">
          <h1 className="title !text-center pt-[24px]">
            Get the <span className="text-pent">.Gold domain</span> you really
            want!
          </h1>
          <p className="home-subtitle">
            Need a .gold domain for your business that&apos;s owned by someone
            else? Or want to sell your .gold domain for a profit? We&apos;re the
            perfect partner, providing cutting-edge brokerage services at
            competitive and affordable prices.
          </p>
        </div>
        <div className="right-j">
          <form className="email-container main-bg" id="email-form">
            <input
              type="text"
              name="domain_name"
              placeholder="Enter your Domain Name"
              className="w-[60%]"
              value={domain}
              onChange={(e) => setDomain(e.target.value)}
            />
            <Button
              variant="contained"
              color="primary"
              className="join-btn custom-btn main-button"
              onClick={handleOpen}
            >
              Hire a Broker
            </Button>
          </form>
        </div>
      </div>

      <dialog id="my_modal_1" className="modal ">
        <div className="modal-box modal-box-graident-border text-center main-bg">
          <div className="main-bg p-[20px] md:p-[40px] rounded-[12px]">
            <form method="dialog">
              <button
                className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                onClick={handleClose}
              >
                ✕
              </button>
            </form>
            {!submitted ? (
              <div className="">
                <h1 className="text-center">
                  <span className="text-pent2 title ">Hire our broker!</span>
                </h1>
                <p className="paragraph text-center my-[12px]">
                  Please provide the your basic details to start with the
                  process
                </p>
                <form
                  ref={form}
                  className="modal-form"
                  onSubmit={handleSubmit}
                  id="modal-form"
                >
                  <TextField
                    label="Name"
                    name="user_name"
                    variant="outlined"
                    fullWidth
                    required
                    margin="normal"
                    size="small"
                  />
                  <TextField
                    label="Email"
                    name="user_email"
                    type="email"
                    variant="outlined"
                    fullWidth
                    required
                    margin="normal"
                    size="small"
                    inputProps={{
                      pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$",
                      title: "Please enter a valid email address.",
                    }}
                  />
                  <TextField
                    label="Mobile Number"
                    name="user_mobile"
                    type="tel"
                    variant="outlined"
                    fullWidth
                    required
                    margin="normal"
                    size="small"
                    inputProps={{
                      pattern: "[6789][0-9]{9}",
                      title:
                        "Mobile number must start with 6/7/8/9 and be 10 digits long.",
                    }}
                  />
                  <RadioGroup name="transaction_type" row margin="normal">
                    <FormControlLabel
                      value="buy"
                      control={<Radio required />}
                      label="Buy"
                    />
                    <FormControlLabel
                      value="sell"
                      control={<Radio required />}
                      label="Sell"
                    />
                  </RadioGroup>
                  <TextField
                    label="Domain Name"
                    name="domain_name"
                    variant="outlined"
                    fullWidth
                    required
                    margin="normal"
                    value={domain}
                    size="small"
                  />
                  <button
                    type="submit"
                    className="w-full mt-[16px] join-btn custom-btn main-button "
                  >
                    {loading ? (
                      <CircularProgress size={24} sx={{ color: "#311e17" }} />
                    ) : (
                      "Get Me a Broker"
                    )}
                  </button>
                </form>
              </div>
            ) : (
              <div className="submitted-message">
                <Lottie
                  animationData={lottie}
                  loop
                  autoplay
                  style={{
                    width: isMobile ? "250px" : "400px",
                    height: isMobile ? "250px" : "400px",
                    background: "transparent",
                    scale: 5,
                    margin: "auto",
                  }}
                />
                <h1 className="title text-center">
                  <span className="text-pent">Thank You!</span>
                </h1>
                <p className="home-subtitle text-center mt-[16px] !mb-[16px]">
                  You took the harder first step! We will take up from here!
                </p>

                <p className="paragraph text-center text-[16px]">
                  One of our business executive will get back to you within 48
                  business hours.
                </p>
              </div>
            )}
          </div>
        </div>
      </dialog>
    </div>
  );
};

export default Join;
